import React from 'react';

export interface ProfileActionProps {
    title: React.ReactNode;
    onClick: () => void;
    icon?: React.ReactNode;
}

const ProfileAction = (props: ProfileActionProps) => {
    return (
        <div
            onClick={props.onClick}
            className='bg-background-surface flex w-full flex-row items-center justify-between gap-5 rounded-2xl px-4 py-3'>
            <div className='text-foreground-default justify-start text-base font-medium'>{props.title}</div>
            {props.icon}
        </div>
    );
};

export default ProfileAction;
